import { topics } from "@/mocks/news";

interface TopicBandProps {
  activeTopic: string;
  onSelect: (topic: string) => void;
}

export default function TopicBand({ activeTopic, onSelect }: TopicBandProps) {
  return (
    <section id="topics" className="w-full border-b border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-widest text-primary-600">TOPICS</span>
            <h2 className="mt-2 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              主题分类
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
              按你关心的话题筛选，点击任意分类即可把上面的实时滚动时间线收窄到对应内容。
            </p>
          </div>
          {activeTopic && (
            <button
              type="button"
              onClick={() => onSelect("")}
              className="flex w-fit cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-2 text-xs text-foreground-700 transition-colors hover:bg-background-200"
            >
              <i className="ri-close-line"></i>
              清除筛选：{activeTopic}
            </button>
          )}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic) => {
            const active = activeTopic === topic.name;
            return (
              <button
                key={topic.id}
                type="button"
                onClick={() => onSelect(active ? "" : topic.name)}
                className={`group flex cursor-pointer flex-col items-start gap-3 rounded-lg border p-5 text-left transition-colors md:p-6 ${
                  active
                    ? "border-primary-300 bg-primary-50"
                    : "border-background-200 bg-background-50 hover:border-primary-200 hover:bg-primary-50/50"
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-md ${
                    active ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"
                  }`}
                >
                  <i className={`${topic.icon} text-xl`}></i>
                </span>
                <span className="flex w-full items-center justify-between gap-2">
                  <span className="font-heading text-lg font-semibold text-foreground-950">{topic.name}</span>
                  <span className="text-xs text-foreground-500">{topic.count} 条</span>
                </span>
                <span className="text-sm leading-relaxed text-foreground-600">{topic.desc}</span>
                <span className="mt-1 flex items-center gap-1 text-xs font-medium text-primary-600">
                  {active ? "已筛选" : "筛选该分类"}
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5"></i>
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </section>
  );
}